// Scroll-driven skier (snippets/ski-run.liquid). Builds a zig-zag run down the full page height,
// keeps the skier at ~40% of the viewport while scrolling, and reveals the track behind him.
(() => {
  const root = document.querySelector('.ski-run');
  if (!root) return;
  const skier = root.querySelector('.ski-run__skier');
  const tracks = [...root.querySelectorAll('.ski-run__track')];
  const path = tracks[0];

  // Where in the viewport the skier sits. On phones he rides in front of the content (see the
  // snippet's CSS) and starts at the top of the product photo, so he's visible from the first screen.
  const mobile = window.matchMedia('(max-width: 749px)');
  const turnHeight = () => (mobile.matches ? 420 : 640); // vertical distance between turns, px
  let mobileAnchor = 0.4;
  const anchor = () => (mobile.matches ? mobileAnchor : 0.4);
  // Top of the visible product photo in page coordinates (0 if there is none on this page).
  const photoTop = () => {
    const media = [...document.querySelectorAll('.product__media-list')].find((el) => el.offsetHeight > 0);
    return media ? media.getBoundingClientRect().top + window.scrollY : 0;
  };
  const MAX_TILT = 32; // degrees

  let total = 0;
  let current = 0;
  let target = 0;
  let facingLeft = false;
  let frame = null;

  const build = () => {
    root.style.height = '0px';
    const width = document.documentElement.clientWidth;
    const height = document.documentElement.scrollHeight;
    root.style.height = `${height}px`;

    // Phones: hug the screen edges so he only crosses the text mid-turn.
    const margin = mobile.matches ? 22 : Math.max(28, width * 0.06);
    const left = margin;
    const right = width - margin;
    const start = mobile.matches ? photoTop() : 0;
    const top = start ? start + 20 : 120;
    if (mobile.matches && start) {
      // On the first screen he sits a little below the photo's top edge.
      mobileAnchor = Math.min(0.6, Math.max(0.25, (start + 90) / window.innerHeight));
    }
    const bottom = height - 80;
    let x = mobile.matches ? margin : width * 0.7;
    let y = top;
    let d = `M${x} ${y}`;
    // Phones start at the left edge, so the first turn heads right (straight into the slalom).
    let goLeft = !mobile.matches;
    // Fixed per-turn wobble (not Math.random) so the run doesn't change shape on every rebuild.
    for (let i = 0; y < bottom; i++) {
      const wobble = mobile.matches ? 0 : (((i * 7919) % 13) / 13) * width * 0.12;
      const ny = Math.min(y + turnHeight(), bottom);
      const nx = goLeft ? left + wobble : right - wobble;
      const k = (ny - y) * 0.55;
      d += ` C${x} ${y + k} ${nx} ${ny - k} ${nx} ${ny}`;
      x = nx;
      y = ny;
      goLeft = !goLeft;
    }
    tracks.forEach((t) => t.setAttribute('d', d));
    total = path.getTotalLength();
    tracks.forEach((t) => {
      t.style.strokeDasharray = `${total} ${total}`;
    });
    current = Math.min(current, total);
    update();
  };

  // Path y grows with length, so binary-search the length whose point is at the wanted y.
  const lengthAtY = (y) => {
    let lo = 0;
    let hi = total;
    for (let i = 0; i < 22; i++) {
      const mid = (lo + hi) / 2;
      if (path.getPointAtLength(mid).y < y) lo = mid;
      else hi = mid;
    }
    return lo;
  };

  const puff = (p) => {
    for (let i = 0; i < 6; i++) {
      const el = document.createElement('span');
      el.className = 'ski-run__puff';
      el.style.left = `${p.x}px`;
      el.style.top = `${p.y}px`;
      el.style.setProperty('--dx', `${(Math.random() - 0.5) * 50}px`);
      el.style.setProperty('--dy', `${-Math.random() * 30}px`);
      root.appendChild(el);
      el.addEventListener('animationend', () => el.remove());
    }
  };

  const draw = () => {
    const p = path.getPointAtLength(current);
    const q = path.getPointAtLength(Math.min(current + 4, total));
    const dx = q.x - p.x;
    const dy = q.y - p.y;
    const left = dx < 0;
    if (left !== facingLeft && Math.abs(dx) > 0.3) {
      facingLeft = left;
      root.classList.toggle('ski-run--left', left);
      puff(p);
    }
    // Tilt down the fall line, but never more than MAX_TILT so he stays on his skis.
    let tilt = (Math.atan2(dy, Math.abs(dx) || 0.001) * 180) / Math.PI;
    tilt = Math.min(MAX_TILT, tilt);
    skier.style.transform = `translate(${p.x}px, ${p.y}px) rotate(${facingLeft ? -tilt : tilt}deg)`;
    tracks.forEach((t) => {
      t.style.strokeDashoffset = `${total - current}`;
    });
  };

  const tick = () => {
    current += (target - current) * 0.12;
    if (Math.abs(target - current) < 0.5) current = target;
    draw();
    frame = current === target ? null : requestAnimationFrame(tick);
  };

  const update = () => {
    if (!total) return;
    target = lengthAtY(window.scrollY + window.innerHeight * anchor());
    if (!frame) frame = requestAnimationFrame(tick);
  };

  let resizeTimer;
  const rebuild = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(build, 200);
  };

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', rebuild);
  new ResizeObserver(rebuild).observe(document.body);
  build();
  current = target;
  draw();
})();
